<div class="promo-kiwi" [class]="theme()" layout layout-horizontal>
  <div padding-large>
    <rt-kiwi-hr-promo
      hasBigHeading="true"
      buttonFitContent="true"
      subheadingFontWeight="default"
      hasPadding="true"
      hasButtonLargeMarginTop="true"
      hasHeadingMarginBottom="true"
      hasSubheadingStrongColor="true"
      [theme]="theme()"
      (ctaClick)="ctaClick.emit()"
    ></rt-kiwi-hr-promo>
  </div>

  <div class="right"></div>
  <div class="close-button-wrapper">
    <rt-icon-button
      variant="plain"
      iconName="close"
      size="small"
      shape="round"
      (click)="close.emit()"
    />
  </div>
</div>
